
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dhbEh", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $7Ndnw = parcelRequire("7Ndnw");


var $7QUD1 = parcelRequire("7QUD1");


var $hIaUw = parcelRequire("hIaUw");


var $8a9Dm = parcelRequire("8a9Dm");


var $dizL5 = parcelRequire("dizL5");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $6UqI3 = parcelRequire("6UqI3");


var $6uUjl = parcelRequire("6uUjl");


var $3IBnw = parcelRequire("3IBnw");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3jwuS = parcelRequire("3jwuS");


var $c54hr = parcelRequire("c54hr");














var $9hlns = parcelRequire("9hlns");


var $9fBoq = parcelRequire("9fBoq");


var $al4VD = parcelRequire("al4VD");

const $ced39bfea5ef5993$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isLoading: isLoading, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_kqswh2mm",
            __cmplp.isLoading ? "_syaz1rpy" : "_syazn7od",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $ced39bfea5ef5993$var$CenterSpinner = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18u0x0bf _19pkx0bf _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
function $ced39bfea5ef5993$export$9f275aff884e1431(t0) {
    const $ = (0, $frIzR.c)(16);
    const { extension: extension, onClick: onClick, isLoading: isLoading } = t0;
    let t1;
    if ($[0] !== extension || $[1] !== onClick) {
        t1 = (e)=>{
            e.stopPropagation();
            onClick(extension);
        };
        $[0] = extension;
        $[1] = onClick;
        $[2] = t1;
    } else t1 = $[2];
    const onClickCB = t1;
    const t2 = extension.id;
    let t3;
    if ($[3] !== extension) {
        t3 = (0, $9fBoq.extensionTitle)(extension);
        $[3] = extension;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== isLoading) {
        t4 = isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$CenterSpinner, {
            "data-test-id": "forge-ui-extension-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "small"
        }));
        $[5] = isLoading;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== isLoading || $[8] !== t3 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$Container, {
            isLoading: isLoading
        }, t3, t4);
        $[7] = isLoading;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== extension.id || $[12] !== isLoading || $[13] !== onClickCB || $[14] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $al4VD.ContentToolsItem), {
            id: t2,
            isDisabled: isLoading,
            label: t5,
            onClick: onClickCB
        });
        $[11] = extension.id;
        $[12] = isLoading;
        $[13] = onClickCB;
        $[14] = t5;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
}
$ced39bfea5ef5993$export$9f275aff884e1431.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool.isRequired
};



var $9MrOn = parcelRequire("9MrOn");

const $0c33e41081c1500e$var$EXPERIENCE_NAME = (0, $irVI7.VIEW_PAGE_CONTENT_TOOLS_FORGE_EXPERIENCE);
function $0c33e41081c1500e$export$7cf22b806dbb23cb({ contentId: contentId, spaceKey: spaceKey, children: children, onLoadComplete: onLoadComplete, isDropdownMenuOpen: isDropdownMenuOpen, lazyLoaderPlaceholderComponent: lazyLoaderPlaceholderComponent = null }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext)); // Forge menu items are behaving a little different than other menu items. They show a loading spinner if one of them
    // is clicked. There are a few different cases that needs to be handled while a forge extension is being loaded:
    // 1. Show a loading spinner while an extension id being loaded.
    //    - Stop showing the loading spinner once the extension is loaded.
    //    - Close the dropdown menu once the extension is loaded.
    // 2. If dropdown menu is closed while an extension is being loaded then stop loading the extension.
    // If there's a selected extension then `loadExtension` state changes like this:
    // +----------+----------------------+------------------+
    // |isLoading |   isDropdownMenuOpen |    loadExtension |
    // +----------------------------------------------------+
    // |          |                      |                  |
    // | false    |   false              |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | false    |   true               |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | true     |   false              |    false         |  --> stop loading the extension
    // |          |                      |                  |
    // | true     |   true               |    true          |  --> keep loading the extension
    // +----------+----------------------+------------------+
    const [extension, showExtension] = (0, $42omo.useState)(null);
    const [isLoading, setLoading] = (0, $42omo.useState)(false);
    const loadExtension = extension && !(isLoading && !isDropdownMenuOpen);
    (0, $42omo.useEffect)(()=>{
        if (!loadExtension) {
            experienceTracker.abort({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
                reason: 'Canceled by user'
            });
            setLoading(false);
            showExtension(null);
        }
    }, [
        loadExtension,
        experienceTracker
    ]);
    const onLoadCompleteCB = (0, $42omo.useCallback)(()=>{
        onLoadComplete();
        setLoading(false);
    }, [
        onLoadComplete,
        setLoading
    ]);
    const onCloseCB = (0, $42omo.useCallback)(()=>{
        showExtension(null);
    }, [
        showExtension
    ]);
    const onForgeExtensionClick = (0, $42omo.useCallback)((ext)=>{
        experienceTracker.start({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
            id: ext.id,
            timeout: 10000
        });
        showExtension(ext);
        setLoading(true);
    }, [
        showExtension,
        setLoading,
        experienceTracker
    ]);
    // shows up when preloaded in SSR. Shows up again when SPA takes over bf all queries are loaded.
    const LazyLoader = (0, $42omo.useMemo)(()=>(0, $dizL5.lazyForgeUIExtensionsWithLoader)(()=>lazyLoaderPlaceholderComponent ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9MrOn.ContentToolsButton // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ), {
                isDisabled: !(window.__SSR_RENDERED__ || undefined)
            })), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, loadExtension && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$ForgeUIExtensionLoader, {
        extension: extension,
        contentId: contentId,
        spaceKey: spaceKey,
        onLoadComplete: onLoadCompleteCB,
        onClose: onCloseCB
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LazyLoader, {
        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
        render: (extensions, loading, error)=>{
            if (loading) return children([]);
            if (error) {
                if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).ECOSYSTEM
                });
                return children([]);
            }
            const result = extensions.map((ext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ced39bfea5ef5993$export$9f275aff884e1431), {
                    key: ext.id,
                    extension: ext,
                    onClick: onForgeExtensionClick,
                    isLoading: extension === ext
                }));
            return children(result);
        }
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c33e41081c1500e$var$InvisibleDiv = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0cglyw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); /**
     * LazyForgeUIExtension has its own loading spinner, however, we don't want to show it anywhere. We want to show a
     * loading spinner inside the menu item while loading the extension, and then close the menu once the loading is complete.
     * To accomplish that, we're rendering LazyForgeUIExtension inside an invisible div.
     * @param forgeExtension To be loaded.
     * @param contentId Passed down to ForgeUIExtension both contentId and spaceKey becomes available in the forge app with
     * `useProductContext` hook. For reference https://developer.atlassian.com/platform/forge/ui-hooks-reference/.
     * @param spaceKey Passed down to ForgeUIExtension.
     * @param onLoadComplete Triggered when the forge extension is loaded.
     * @param onClose Triggered when the rendered ModalDialog is closed. (Currently ContentAction forge component can only contain a ModalDialog)
     * @returns LazyForgeUIExtension inside an InvisibleDiv.
     * @constructor
     */ 
function $0c33e41081c1500e$var$ForgeUIExtensionLoader(t0) {
    const $ = (0, $frIzR.c)(33);
    const { extension: extension, contentId: contentId, spaceKey: spaceAlias, onLoadComplete: onLoadComplete, onClose: onClose } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [t1] = (0, $ep3mz.usePageState)();
    const { routeName: routeName } = t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { setIsCloseMenuDisabled: setIsCloseMenuDisabled } = (0, $c54hr.useMoreActionsMenuActions)();
    let t2;
    let t3;
    if ($[0] !== setIsCloseMenuDisabled) {
        t2 = ()=>{
            setIsCloseMenuDisabled(true);
            return ()=>{
                setIsCloseMenuDisabled(false);
            };
        };
        t3 = [
            setIsCloseMenuDisabled
        ];
        $[0] = setIsCloseMenuDisabled;
        $[1] = t2;
        $[2] = t3;
    } else {
        t2 = $[1];
        t3 = $[2];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[3] !== activationId || $[4] !== contentId || $[5] !== createAnalyticsEvent || $[6] !== experienceTracker || $[7] !== extension || $[8] !== onLoadComplete || $[9] !== routeName || $[10] !== spaceAlias || $[11] !== spaceId) {
        t4 = ()=>{
            experienceTracker.succeed({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME
            });
            onLoadComplete();
            const appId = (0, $8a9Dm.getAppId)(extension);
            const analyticEvent = createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "invoked",
                    actionSubject: "forgeExtension",
                    actionSubjectId: appId,
                    containerType: "space",
                    containerId: spaceId,
                    objectType: (0, $hIaUw.getContentType)(routeName),
                    objectId: contentId,
                    source: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                    attributes: {
                        activationId: activationId,
                        appId: appId,
                        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                        moduleKey: (0, $8a9Dm.getModuleKey)(extension),
                        spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                        spaceId: spaceId
                    }
                }
            });
            analyticEvent.fire();
        };
        $[3] = activationId;
        $[4] = contentId;
        $[5] = createAnalyticsEvent;
        $[6] = experienceTracker;
        $[7] = extension;
        $[8] = onLoadComplete;
        $[9] = routeName;
        $[10] = spaceAlias;
        $[11] = spaceId;
        $[12] = t4;
    } else t4 = $[12];
    const onInitialRender = t4;
    if (!spaceKey) return null;
    const t5 = extension.id;
    const t6 = isLivePage ? "live" : null;
    let t7;
    if ($[13] !== routeName) {
        t7 = (0, $hIaUw.getContentType)(routeName);
        $[13] = routeName;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== contentId || $[16] !== t6 || $[17] !== t7) {
        t8 = {
            id: contentId,
            subtype: t6,
            type: t7
        };
        $[15] = contentId;
        $[16] = t6;
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    const t9 = spaceKey || spaceAlias;
    let t10;
    if ($[19] !== spaceId || $[20] !== t9) {
        t10 = {
            key: t9,
            id: spaceId
        };
        $[19] = spaceId;
        $[20] = t9;
        $[21] = t10;
    } else t10 = $[21];
    let t11;
    if ($[22] !== t10 || $[23] !== t8) {
        t11 = {
            type: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
            content: t8,
            space: t10
        };
        $[22] = t10;
        $[23] = t8;
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== onClose || $[26] !== setIsCloseMenuDisabled) {
        t12 = ()=>{
            setIsCloseMenuDisabled(false);
            onClose();
        };
        $[25] = onClose;
        $[26] = setIsCloseMenuDisabled;
        $[27] = t12;
    } else t12 = $[27];
    let t13;
    if ($[28] !== extension || $[29] !== onInitialRender || $[30] !== t11 || $[31] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.ContentActionForgeApp), {
            key: t5,
            app: extension,
            extensionData: t11,
            onInitialRender: onInitialRender,
            onTearDown: t12
        }));
        $[28] = extension;
        $[29] = onInitialRender;
        $[30] = t11;
        $[31] = t12;
        $[32] = t13;
    } else t13 = $[32];
    return t13;
}
$0c33e41081c1500e$var$ForgeUIExtensionLoader.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    onLoadComplete: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
module.exports["ForgeContentTools"] = $0c33e41081c1500e$export$7cf22b806dbb23cb;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("5vQst"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("9fey7"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("az133"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("89BvH"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("03Cg4"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("4JGSj"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("6L7Ck"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("hUsie"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("MfL8R"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("2q0Fw"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("8z6ju"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("jH0o4"))).PageBannerForgeApp
});
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("5vQst", function(module, exports) {

let $40388a1c5c644823$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $40388a1c5c644823$var$load("2YffH"),
    $40388a1c5c644823$var$load("1o23t"),
    $40388a1c5c644823$var$load("lqFMg"),
    $40388a1c5c644823$var$load("kNlhf"),
    $40388a1c5c644823$var$load("jbZIC"),
    $40388a1c5c644823$var$load("l1nJ9"),
    $40388a1c5c644823$var$load("iQ0Jm"),
    $40388a1c5c644823$var$load("eBRUf"),
    $40388a1c5c644823$var$load("GYf7c"),
    $40388a1c5c644823$var$load("ceKWn"),
    $40388a1c5c644823$var$load("h4Nf7"),
    $40388a1c5c644823$var$load("7f9Fz"),
    $40388a1c5c644823$var$load("8YSo7"),
    $40388a1c5c644823$var$load("3WB19"),
    $40388a1c5c644823$var$load("g9CVe"),
    $40388a1c5c644823$var$load("fSobj"),
    $40388a1c5c644823$var$load("74u2y"),
    $40388a1c5c644823$var$load("6wr18"),
    $40388a1c5c644823$var$load("kjZZD"),
    $40388a1c5c644823$var$load("jjLHK"),
    $40388a1c5c644823$var$load("cxoS1"),
    $40388a1c5c644823$var$load("dRpV3"),
    $40388a1c5c644823$var$load("ffEVr"),
    $40388a1c5c644823$var$load("jwTn5"),
    $40388a1c5c644823$var$load("aYdgM"),
    $40388a1c5c644823$var$load("6u1hm"),
    $40388a1c5c644823$var$load("klApM"),
    $40388a1c5c644823$var$load("eQgf0"),
    $40388a1c5c644823$var$load("2vAWg"),
    $40388a1c5c644823$var$load("7cABH"),
    $40388a1c5c644823$var$load("4UuEP"),
    $40388a1c5c644823$var$load("74vOE"),
    $40388a1c5c644823$var$load("2uVTT"),
    $40388a1c5c644823$var$load("hhss7"),
    $40388a1c5c644823$var$load("Wowvf"),
    $40388a1c5c644823$var$load("cJcjb"),
    $40388a1c5c644823$var$load("hJpvQ"),
    $40388a1c5c644823$var$load("bIPPg"),
    $40388a1c5c644823$var$load("lnKog"),
    $40388a1c5c644823$var$load("h3ABO"),
    $40388a1c5c644823$var$load("kC80R"),
    $40388a1c5c644823$var$load("7EorR"),
    $40388a1c5c644823$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("9fey7", function(module, exports) {

let $6bb0ccf70a6a56ed$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6bb0ccf70a6a56ed$var$load("2YffH"),
    $6bb0ccf70a6a56ed$var$load("1o23t"),
    $6bb0ccf70a6a56ed$var$load("lqFMg"),
    $6bb0ccf70a6a56ed$var$load("kNlhf"),
    $6bb0ccf70a6a56ed$var$load("jbZIC"),
    $6bb0ccf70a6a56ed$var$load("l1nJ9"),
    $6bb0ccf70a6a56ed$var$load("iQ0Jm"),
    $6bb0ccf70a6a56ed$var$load("eBRUf"),
    $6bb0ccf70a6a56ed$var$load("GYf7c"),
    $6bb0ccf70a6a56ed$var$load("ceKWn"),
    $6bb0ccf70a6a56ed$var$load("h4Nf7"),
    $6bb0ccf70a6a56ed$var$load("7f9Fz"),
    $6bb0ccf70a6a56ed$var$load("8YSo7"),
    $6bb0ccf70a6a56ed$var$load("3WB19"),
    $6bb0ccf70a6a56ed$var$load("g9CVe"),
    $6bb0ccf70a6a56ed$var$load("fSobj"),
    $6bb0ccf70a6a56ed$var$load("74u2y"),
    $6bb0ccf70a6a56ed$var$load("6wr18"),
    $6bb0ccf70a6a56ed$var$load("kjZZD"),
    $6bb0ccf70a6a56ed$var$load("jjLHK"),
    $6bb0ccf70a6a56ed$var$load("cxoS1"),
    $6bb0ccf70a6a56ed$var$load("dRpV3"),
    $6bb0ccf70a6a56ed$var$load("ffEVr"),
    $6bb0ccf70a6a56ed$var$load("jwTn5"),
    $6bb0ccf70a6a56ed$var$load("aYdgM"),
    $6bb0ccf70a6a56ed$var$load("6u1hm"),
    $6bb0ccf70a6a56ed$var$load("klApM"),
    $6bb0ccf70a6a56ed$var$load("eQgf0"),
    $6bb0ccf70a6a56ed$var$load("2vAWg"),
    $6bb0ccf70a6a56ed$var$load("7cABH"),
    $6bb0ccf70a6a56ed$var$load("4UuEP"),
    $6bb0ccf70a6a56ed$var$load("74vOE"),
    $6bb0ccf70a6a56ed$var$load("2uVTT"),
    $6bb0ccf70a6a56ed$var$load("hhss7"),
    $6bb0ccf70a6a56ed$var$load("Wowvf"),
    $6bb0ccf70a6a56ed$var$load("cJcjb"),
    $6bb0ccf70a6a56ed$var$load("hJpvQ"),
    $6bb0ccf70a6a56ed$var$load("bIPPg"),
    $6bb0ccf70a6a56ed$var$load("lnKog"),
    $6bb0ccf70a6a56ed$var$load("h3ABO"),
    $6bb0ccf70a6a56ed$var$load("kC80R"),
    $6bb0ccf70a6a56ed$var$load("7EorR"),
    $6bb0ccf70a6a56ed$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("az133", function(module, exports) {

let $7b0dfc6f5e1a37ea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7b0dfc6f5e1a37ea$var$load("2YffH"),
    $7b0dfc6f5e1a37ea$var$load("1o23t"),
    $7b0dfc6f5e1a37ea$var$load("lqFMg"),
    $7b0dfc6f5e1a37ea$var$load("kNlhf"),
    $7b0dfc6f5e1a37ea$var$load("jbZIC"),
    $7b0dfc6f5e1a37ea$var$load("l1nJ9"),
    $7b0dfc6f5e1a37ea$var$load("iQ0Jm"),
    $7b0dfc6f5e1a37ea$var$load("eBRUf"),
    $7b0dfc6f5e1a37ea$var$load("GYf7c"),
    $7b0dfc6f5e1a37ea$var$load("ceKWn"),
    $7b0dfc6f5e1a37ea$var$load("h4Nf7"),
    $7b0dfc6f5e1a37ea$var$load("7f9Fz"),
    $7b0dfc6f5e1a37ea$var$load("8YSo7"),
    $7b0dfc6f5e1a37ea$var$load("3WB19"),
    $7b0dfc6f5e1a37ea$var$load("g9CVe"),
    $7b0dfc6f5e1a37ea$var$load("fSobj"),
    $7b0dfc6f5e1a37ea$var$load("74u2y"),
    $7b0dfc6f5e1a37ea$var$load("6wr18"),
    $7b0dfc6f5e1a37ea$var$load("kjZZD"),
    $7b0dfc6f5e1a37ea$var$load("jjLHK"),
    $7b0dfc6f5e1a37ea$var$load("cxoS1"),
    $7b0dfc6f5e1a37ea$var$load("dRpV3"),
    $7b0dfc6f5e1a37ea$var$load("ffEVr"),
    $7b0dfc6f5e1a37ea$var$load("jwTn5"),
    $7b0dfc6f5e1a37ea$var$load("aYdgM"),
    $7b0dfc6f5e1a37ea$var$load("6u1hm"),
    $7b0dfc6f5e1a37ea$var$load("klApM"),
    $7b0dfc6f5e1a37ea$var$load("eQgf0"),
    $7b0dfc6f5e1a37ea$var$load("2vAWg"),
    $7b0dfc6f5e1a37ea$var$load("7cABH"),
    $7b0dfc6f5e1a37ea$var$load("4UuEP"),
    $7b0dfc6f5e1a37ea$var$load("74vOE"),
    $7b0dfc6f5e1a37ea$var$load("2uVTT"),
    $7b0dfc6f5e1a37ea$var$load("hhss7"),
    $7b0dfc6f5e1a37ea$var$load("Wowvf"),
    $7b0dfc6f5e1a37ea$var$load("cJcjb"),
    $7b0dfc6f5e1a37ea$var$load("hJpvQ"),
    $7b0dfc6f5e1a37ea$var$load("bIPPg"),
    $7b0dfc6f5e1a37ea$var$load("lnKog"),
    $7b0dfc6f5e1a37ea$var$load("h3ABO"),
    $7b0dfc6f5e1a37ea$var$load("kC80R"),
    $7b0dfc6f5e1a37ea$var$load("7EorR"),
    $7b0dfc6f5e1a37ea$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("89BvH", function(module, exports) {

let $5efc42bf9a6ee4d0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5efc42bf9a6ee4d0$var$load("2YffH"),
    $5efc42bf9a6ee4d0$var$load("lqFMg"),
    $5efc42bf9a6ee4d0$var$load("kNlhf"),
    $5efc42bf9a6ee4d0$var$load("jbZIC"),
    $5efc42bf9a6ee4d0$var$load("hJpvQ"),
    $5efc42bf9a6ee4d0$var$load("l1nJ9"),
    $5efc42bf9a6ee4d0$var$load("eBRUf"),
    $5efc42bf9a6ee4d0$var$load("GYf7c"),
    $5efc42bf9a6ee4d0$var$load("ceKWn"),
    $5efc42bf9a6ee4d0$var$load("h4Nf7"),
    $5efc42bf9a6ee4d0$var$load("7f9Fz"),
    $5efc42bf9a6ee4d0$var$load("8YSo7"),
    $5efc42bf9a6ee4d0$var$load("g9CVe"),
    $5efc42bf9a6ee4d0$var$load("fSobj"),
    $5efc42bf9a6ee4d0$var$load("74u2y"),
    $5efc42bf9a6ee4d0$var$load("6wr18"),
    $5efc42bf9a6ee4d0$var$load("kjZZD"),
    $5efc42bf9a6ee4d0$var$load("jjLHK"),
    $5efc42bf9a6ee4d0$var$load("cxoS1"),
    $5efc42bf9a6ee4d0$var$load("dRpV3"),
    $5efc42bf9a6ee4d0$var$load("ffEVr"),
    $5efc42bf9a6ee4d0$var$load("jwTn5"),
    $5efc42bf9a6ee4d0$var$load("aYdgM"),
    $5efc42bf9a6ee4d0$var$load("6u1hm"),
    $5efc42bf9a6ee4d0$var$load("klApM"),
    $5efc42bf9a6ee4d0$var$load("eQgf0"),
    $5efc42bf9a6ee4d0$var$load("2vAWg"),
    $5efc42bf9a6ee4d0$var$load("7cABH"),
    $5efc42bf9a6ee4d0$var$load("4UuEP"),
    $5efc42bf9a6ee4d0$var$load("74vOE"),
    $5efc42bf9a6ee4d0$var$load("bIPPg"),
    $5efc42bf9a6ee4d0$var$load("2uVTT"),
    $5efc42bf9a6ee4d0$var$load("hhss7"),
    $5efc42bf9a6ee4d0$var$load("Wowvf"),
    $5efc42bf9a6ee4d0$var$load("cJcjb"),
    $5efc42bf9a6ee4d0$var$load("h3ABO"),
    $5efc42bf9a6ee4d0$var$load("kC80R"),
    $5efc42bf9a6ee4d0$var$load("7EorR"),
    $5efc42bf9a6ee4d0$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("03Cg4", function(module, exports) {

let $00adf5342303fa54$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $00adf5342303fa54$var$load("2YffH"),
    $00adf5342303fa54$var$load("lqFMg"),
    $00adf5342303fa54$var$load("kNlhf"),
    $00adf5342303fa54$var$load("jbZIC"),
    $00adf5342303fa54$var$load("hJpvQ"),
    $00adf5342303fa54$var$load("l1nJ9"),
    $00adf5342303fa54$var$load("eBRUf"),
    $00adf5342303fa54$var$load("GYf7c"),
    $00adf5342303fa54$var$load("ceKWn"),
    $00adf5342303fa54$var$load("h4Nf7"),
    $00adf5342303fa54$var$load("7f9Fz"),
    $00adf5342303fa54$var$load("8YSo7"),
    $00adf5342303fa54$var$load("g9CVe"),
    $00adf5342303fa54$var$load("fSobj"),
    $00adf5342303fa54$var$load("74u2y"),
    $00adf5342303fa54$var$load("6wr18"),
    $00adf5342303fa54$var$load("kjZZD"),
    $00adf5342303fa54$var$load("jjLHK"),
    $00adf5342303fa54$var$load("cxoS1"),
    $00adf5342303fa54$var$load("dRpV3"),
    $00adf5342303fa54$var$load("ffEVr"),
    $00adf5342303fa54$var$load("jwTn5"),
    $00adf5342303fa54$var$load("aYdgM"),
    $00adf5342303fa54$var$load("6u1hm"),
    $00adf5342303fa54$var$load("klApM"),
    $00adf5342303fa54$var$load("eQgf0"),
    $00adf5342303fa54$var$load("2vAWg"),
    $00adf5342303fa54$var$load("7cABH"),
    $00adf5342303fa54$var$load("4UuEP"),
    $00adf5342303fa54$var$load("74vOE"),
    $00adf5342303fa54$var$load("bIPPg"),
    $00adf5342303fa54$var$load("2uVTT"),
    $00adf5342303fa54$var$load("hhss7"),
    $00adf5342303fa54$var$load("Wowvf"),
    $00adf5342303fa54$var$load("cJcjb"),
    $00adf5342303fa54$var$load("h3ABO"),
    $00adf5342303fa54$var$load("kC80R"),
    $00adf5342303fa54$var$load("7EorR"),
    $00adf5342303fa54$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("4JGSj", function(module, exports) {

let $372c9f7d9f50d72a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $372c9f7d9f50d72a$var$load("2YffH"),
    $372c9f7d9f50d72a$var$load("lqFMg"),
    $372c9f7d9f50d72a$var$load("kNlhf"),
    $372c9f7d9f50d72a$var$load("jbZIC"),
    $372c9f7d9f50d72a$var$load("hJpvQ"),
    $372c9f7d9f50d72a$var$load("l1nJ9"),
    $372c9f7d9f50d72a$var$load("eBRUf"),
    $372c9f7d9f50d72a$var$load("GYf7c"),
    $372c9f7d9f50d72a$var$load("ceKWn"),
    $372c9f7d9f50d72a$var$load("h4Nf7"),
    $372c9f7d9f50d72a$var$load("7f9Fz"),
    $372c9f7d9f50d72a$var$load("8YSo7"),
    $372c9f7d9f50d72a$var$load("g9CVe"),
    $372c9f7d9f50d72a$var$load("fSobj"),
    $372c9f7d9f50d72a$var$load("74u2y"),
    $372c9f7d9f50d72a$var$load("6wr18"),
    $372c9f7d9f50d72a$var$load("kjZZD"),
    $372c9f7d9f50d72a$var$load("jjLHK"),
    $372c9f7d9f50d72a$var$load("cxoS1"),
    $372c9f7d9f50d72a$var$load("dRpV3"),
    $372c9f7d9f50d72a$var$load("ffEVr"),
    $372c9f7d9f50d72a$var$load("jwTn5"),
    $372c9f7d9f50d72a$var$load("aYdgM"),
    $372c9f7d9f50d72a$var$load("6u1hm"),
    $372c9f7d9f50d72a$var$load("klApM"),
    $372c9f7d9f50d72a$var$load("eQgf0"),
    $372c9f7d9f50d72a$var$load("2vAWg"),
    $372c9f7d9f50d72a$var$load("7cABH"),
    $372c9f7d9f50d72a$var$load("4UuEP"),
    $372c9f7d9f50d72a$var$load("74vOE"),
    $372c9f7d9f50d72a$var$load("bIPPg"),
    $372c9f7d9f50d72a$var$load("2uVTT"),
    $372c9f7d9f50d72a$var$load("hhss7"),
    $372c9f7d9f50d72a$var$load("Wowvf"),
    $372c9f7d9f50d72a$var$load("cJcjb"),
    $372c9f7d9f50d72a$var$load("h3ABO"),
    $372c9f7d9f50d72a$var$load("kC80R"),
    $372c9f7d9f50d72a$var$load("7EorR"),
    $372c9f7d9f50d72a$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("6L7Ck", function(module, exports) {

let $4ebd0a74a411770c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4ebd0a74a411770c$var$load("2YffH"),
    $4ebd0a74a411770c$var$load("lqFMg"),
    $4ebd0a74a411770c$var$load("kNlhf"),
    $4ebd0a74a411770c$var$load("jbZIC"),
    $4ebd0a74a411770c$var$load("l1nJ9"),
    $4ebd0a74a411770c$var$load("eBRUf"),
    $4ebd0a74a411770c$var$load("GYf7c"),
    $4ebd0a74a411770c$var$load("ceKWn"),
    $4ebd0a74a411770c$var$load("h4Nf7"),
    $4ebd0a74a411770c$var$load("7f9Fz"),
    $4ebd0a74a411770c$var$load("8YSo7"),
    $4ebd0a74a411770c$var$load("g9CVe"),
    $4ebd0a74a411770c$var$load("fSobj"),
    $4ebd0a74a411770c$var$load("74u2y"),
    $4ebd0a74a411770c$var$load("6wr18"),
    $4ebd0a74a411770c$var$load("kjZZD"),
    $4ebd0a74a411770c$var$load("jjLHK"),
    $4ebd0a74a411770c$var$load("cxoS1"),
    $4ebd0a74a411770c$var$load("dRpV3"),
    $4ebd0a74a411770c$var$load("ffEVr"),
    $4ebd0a74a411770c$var$load("jwTn5"),
    $4ebd0a74a411770c$var$load("aYdgM"),
    $4ebd0a74a411770c$var$load("6u1hm"),
    $4ebd0a74a411770c$var$load("klApM"),
    $4ebd0a74a411770c$var$load("eQgf0"),
    $4ebd0a74a411770c$var$load("2vAWg"),
    $4ebd0a74a411770c$var$load("7cABH"),
    $4ebd0a74a411770c$var$load("4UuEP"),
    $4ebd0a74a411770c$var$load("74vOE"),
    $4ebd0a74a411770c$var$load("2uVTT"),
    $4ebd0a74a411770c$var$load("hhss7"),
    $4ebd0a74a411770c$var$load("Wowvf"),
    $4ebd0a74a411770c$var$load("cJcjb"),
    $4ebd0a74a411770c$var$load("hJpvQ"),
    $4ebd0a74a411770c$var$load("bIPPg"),
    $4ebd0a74a411770c$var$load("lnKog"),
    $4ebd0a74a411770c$var$load("h3ABO"),
    $4ebd0a74a411770c$var$load("kC80R"),
    $4ebd0a74a411770c$var$load("7EorR"),
    $4ebd0a74a411770c$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("hUsie", function(module, exports) {

let $d09d9d06f41d15f0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d09d9d06f41d15f0$var$load("2YffH"),
    $d09d9d06f41d15f0$var$load("lqFMg"),
    $d09d9d06f41d15f0$var$load("kNlhf"),
    $d09d9d06f41d15f0$var$load("jbZIC"),
    $d09d9d06f41d15f0$var$load("l1nJ9"),
    $d09d9d06f41d15f0$var$load("eBRUf"),
    $d09d9d06f41d15f0$var$load("GYf7c"),
    $d09d9d06f41d15f0$var$load("ceKWn"),
    $d09d9d06f41d15f0$var$load("h4Nf7"),
    $d09d9d06f41d15f0$var$load("7f9Fz"),
    $d09d9d06f41d15f0$var$load("8YSo7"),
    $d09d9d06f41d15f0$var$load("3WB19"),
    $d09d9d06f41d15f0$var$load("g9CVe"),
    $d09d9d06f41d15f0$var$load("fSobj"),
    $d09d9d06f41d15f0$var$load("74u2y"),
    $d09d9d06f41d15f0$var$load("6wr18"),
    $d09d9d06f41d15f0$var$load("kjZZD"),
    $d09d9d06f41d15f0$var$load("jjLHK"),
    $d09d9d06f41d15f0$var$load("cxoS1"),
    $d09d9d06f41d15f0$var$load("dRpV3"),
    $d09d9d06f41d15f0$var$load("ffEVr"),
    $d09d9d06f41d15f0$var$load("dTsOE"),
    $d09d9d06f41d15f0$var$load("jwTn5"),
    $d09d9d06f41d15f0$var$load("aYdgM"),
    $d09d9d06f41d15f0$var$load("6u1hm"),
    $d09d9d06f41d15f0$var$load("klApM"),
    $d09d9d06f41d15f0$var$load("eQgf0"),
    $d09d9d06f41d15f0$var$load("2vAWg"),
    $d09d9d06f41d15f0$var$load("7cABH"),
    $d09d9d06f41d15f0$var$load("4UuEP"),
    $d09d9d06f41d15f0$var$load("74vOE"),
    $d09d9d06f41d15f0$var$load("2uVTT"),
    $d09d9d06f41d15f0$var$load("hhss7"),
    $d09d9d06f41d15f0$var$load("Wowvf"),
    $d09d9d06f41d15f0$var$load("cJcjb"),
    $d09d9d06f41d15f0$var$load("hJpvQ"),
    $d09d9d06f41d15f0$var$load("bIPPg"),
    $d09d9d06f41d15f0$var$load("lnKog"),
    $d09d9d06f41d15f0$var$load("h3ABO"),
    $d09d9d06f41d15f0$var$load("kC80R"),
    $d09d9d06f41d15f0$var$load("7EorR"),
    $d09d9d06f41d15f0$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("MfL8R", function(module, exports) {

let $0910b549f9e4d0f2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0910b549f9e4d0f2$var$load("2YffH"),
    $0910b549f9e4d0f2$var$load("lqFMg"),
    $0910b549f9e4d0f2$var$load("kNlhf"),
    $0910b549f9e4d0f2$var$load("jbZIC"),
    $0910b549f9e4d0f2$var$load("l1nJ9"),
    $0910b549f9e4d0f2$var$load("eBRUf"),
    $0910b549f9e4d0f2$var$load("GYf7c"),
    $0910b549f9e4d0f2$var$load("ceKWn"),
    $0910b549f9e4d0f2$var$load("h4Nf7"),
    $0910b549f9e4d0f2$var$load("7f9Fz"),
    $0910b549f9e4d0f2$var$load("8YSo7"),
    $0910b549f9e4d0f2$var$load("3WB19"),
    $0910b549f9e4d0f2$var$load("g9CVe"),
    $0910b549f9e4d0f2$var$load("fSobj"),
    $0910b549f9e4d0f2$var$load("74u2y"),
    $0910b549f9e4d0f2$var$load("6wr18"),
    $0910b549f9e4d0f2$var$load("kjZZD"),
    $0910b549f9e4d0f2$var$load("jjLHK"),
    $0910b549f9e4d0f2$var$load("cxoS1"),
    $0910b549f9e4d0f2$var$load("dRpV3"),
    $0910b549f9e4d0f2$var$load("ffEVr"),
    $0910b549f9e4d0f2$var$load("dTsOE"),
    $0910b549f9e4d0f2$var$load("jwTn5"),
    $0910b549f9e4d0f2$var$load("aYdgM"),
    $0910b549f9e4d0f2$var$load("6u1hm"),
    $0910b549f9e4d0f2$var$load("klApM"),
    $0910b549f9e4d0f2$var$load("eQgf0"),
    $0910b549f9e4d0f2$var$load("2vAWg"),
    $0910b549f9e4d0f2$var$load("7cABH"),
    $0910b549f9e4d0f2$var$load("4UuEP"),
    $0910b549f9e4d0f2$var$load("74vOE"),
    $0910b549f9e4d0f2$var$load("2uVTT"),
    $0910b549f9e4d0f2$var$load("hhss7"),
    $0910b549f9e4d0f2$var$load("Wowvf"),
    $0910b549f9e4d0f2$var$load("cJcjb"),
    $0910b549f9e4d0f2$var$load("hJpvQ"),
    $0910b549f9e4d0f2$var$load("bIPPg"),
    $0910b549f9e4d0f2$var$load("lnKog"),
    $0910b549f9e4d0f2$var$load("h3ABO"),
    $0910b549f9e4d0f2$var$load("kC80R"),
    $0910b549f9e4d0f2$var$load("7EorR"),
    $0910b549f9e4d0f2$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("2q0Fw", function(module, exports) {

let $1c2e87428b795ada$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1c2e87428b795ada$var$load("2YffH"),
    $1c2e87428b795ada$var$load("lqFMg"),
    $1c2e87428b795ada$var$load("kNlhf"),
    $1c2e87428b795ada$var$load("jbZIC"),
    $1c2e87428b795ada$var$load("hJpvQ"),
    $1c2e87428b795ada$var$load("l1nJ9"),
    $1c2e87428b795ada$var$load("eBRUf"),
    $1c2e87428b795ada$var$load("GYf7c"),
    $1c2e87428b795ada$var$load("ceKWn"),
    $1c2e87428b795ada$var$load("h4Nf7"),
    $1c2e87428b795ada$var$load("7f9Fz"),
    $1c2e87428b795ada$var$load("8YSo7"),
    $1c2e87428b795ada$var$load("g9CVe"),
    $1c2e87428b795ada$var$load("fSobj"),
    $1c2e87428b795ada$var$load("74u2y"),
    $1c2e87428b795ada$var$load("6wr18"),
    $1c2e87428b795ada$var$load("kjZZD"),
    $1c2e87428b795ada$var$load("jjLHK"),
    $1c2e87428b795ada$var$load("cxoS1"),
    $1c2e87428b795ada$var$load("dRpV3"),
    $1c2e87428b795ada$var$load("ffEVr"),
    $1c2e87428b795ada$var$load("jwTn5"),
    $1c2e87428b795ada$var$load("aYdgM"),
    $1c2e87428b795ada$var$load("6u1hm"),
    $1c2e87428b795ada$var$load("klApM"),
    $1c2e87428b795ada$var$load("eQgf0"),
    $1c2e87428b795ada$var$load("2vAWg"),
    $1c2e87428b795ada$var$load("7cABH"),
    $1c2e87428b795ada$var$load("4UuEP"),
    $1c2e87428b795ada$var$load("74vOE"),
    $1c2e87428b795ada$var$load("bIPPg"),
    $1c2e87428b795ada$var$load("2uVTT"),
    $1c2e87428b795ada$var$load("hhss7"),
    $1c2e87428b795ada$var$load("Wowvf"),
    $1c2e87428b795ada$var$load("cJcjb"),
    $1c2e87428b795ada$var$load("h3ABO"),
    $1c2e87428b795ada$var$load("kC80R"),
    $1c2e87428b795ada$var$load("7EorR"),
    $1c2e87428b795ada$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("8z6ju", function(module, exports) {

let $63c67d4c8d28e2a4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $63c67d4c8d28e2a4$var$load("2YffH"),
    $63c67d4c8d28e2a4$var$load("lqFMg"),
    $63c67d4c8d28e2a4$var$load("kNlhf"),
    $63c67d4c8d28e2a4$var$load("jbZIC"),
    $63c67d4c8d28e2a4$var$load("l1nJ9"),
    $63c67d4c8d28e2a4$var$load("eBRUf"),
    $63c67d4c8d28e2a4$var$load("GYf7c"),
    $63c67d4c8d28e2a4$var$load("ceKWn"),
    $63c67d4c8d28e2a4$var$load("h4Nf7"),
    $63c67d4c8d28e2a4$var$load("7f9Fz"),
    $63c67d4c8d28e2a4$var$load("8YSo7"),
    $63c67d4c8d28e2a4$var$load("g9CVe"),
    $63c67d4c8d28e2a4$var$load("fSobj"),
    $63c67d4c8d28e2a4$var$load("74u2y"),
    $63c67d4c8d28e2a4$var$load("6wr18"),
    $63c67d4c8d28e2a4$var$load("kjZZD"),
    $63c67d4c8d28e2a4$var$load("jjLHK"),
    $63c67d4c8d28e2a4$var$load("cxoS1"),
    $63c67d4c8d28e2a4$var$load("dRpV3"),
    $63c67d4c8d28e2a4$var$load("ffEVr"),
    $63c67d4c8d28e2a4$var$load("jwTn5"),
    $63c67d4c8d28e2a4$var$load("aYdgM"),
    $63c67d4c8d28e2a4$var$load("6u1hm"),
    $63c67d4c8d28e2a4$var$load("klApM"),
    $63c67d4c8d28e2a4$var$load("eQgf0"),
    $63c67d4c8d28e2a4$var$load("2vAWg"),
    $63c67d4c8d28e2a4$var$load("7cABH"),
    $63c67d4c8d28e2a4$var$load("4UuEP"),
    $63c67d4c8d28e2a4$var$load("74vOE"),
    $63c67d4c8d28e2a4$var$load("2uVTT"),
    $63c67d4c8d28e2a4$var$load("hhss7"),
    $63c67d4c8d28e2a4$var$load("Wowvf"),
    $63c67d4c8d28e2a4$var$load("cJcjb"),
    $63c67d4c8d28e2a4$var$load("hJpvQ"),
    $63c67d4c8d28e2a4$var$load("bIPPg"),
    $63c67d4c8d28e2a4$var$load("lnKog"),
    $63c67d4c8d28e2a4$var$load("h3ABO"),
    $63c67d4c8d28e2a4$var$load("kC80R"),
    $63c67d4c8d28e2a4$var$load("7EorR"),
    $63c67d4c8d28e2a4$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("jH0o4", function(module, exports) {

let $e5625560a29d73bd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e5625560a29d73bd$var$load("2YffH"),
    $e5625560a29d73bd$var$load("lqFMg"),
    $e5625560a29d73bd$var$load("kNlhf"),
    $e5625560a29d73bd$var$load("jbZIC"),
    $e5625560a29d73bd$var$load("l1nJ9"),
    $e5625560a29d73bd$var$load("eBRUf"),
    $e5625560a29d73bd$var$load("GYf7c"),
    $e5625560a29d73bd$var$load("ceKWn"),
    $e5625560a29d73bd$var$load("h4Nf7"),
    $e5625560a29d73bd$var$load("7f9Fz"),
    $e5625560a29d73bd$var$load("8YSo7"),
    $e5625560a29d73bd$var$load("g9CVe"),
    $e5625560a29d73bd$var$load("fSobj"),
    $e5625560a29d73bd$var$load("74u2y"),
    $e5625560a29d73bd$var$load("6wr18"),
    $e5625560a29d73bd$var$load("kjZZD"),
    $e5625560a29d73bd$var$load("jjLHK"),
    $e5625560a29d73bd$var$load("cxoS1"),
    $e5625560a29d73bd$var$load("dRpV3"),
    $e5625560a29d73bd$var$load("ffEVr"),
    $e5625560a29d73bd$var$load("jwTn5"),
    $e5625560a29d73bd$var$load("aYdgM"),
    $e5625560a29d73bd$var$load("6u1hm"),
    $e5625560a29d73bd$var$load("klApM"),
    $e5625560a29d73bd$var$load("eQgf0"),
    $e5625560a29d73bd$var$load("2vAWg"),
    $e5625560a29d73bd$var$load("7cABH"),
    $e5625560a29d73bd$var$load("4UuEP"),
    $e5625560a29d73bd$var$load("74vOE"),
    $e5625560a29d73bd$var$load("2uVTT"),
    $e5625560a29d73bd$var$load("hhss7"),
    $e5625560a29d73bd$var$load("Wowvf"),
    $e5625560a29d73bd$var$load("cJcjb"),
    $e5625560a29d73bd$var$load("hJpvQ"),
    $e5625560a29d73bd$var$load("bIPPg"),
    $e5625560a29d73bd$var$load("lnKog"),
    $e5625560a29d73bd$var$load("h3ABO"),
    $e5625560a29d73bd$var$load("kC80R"),
    $e5625560a29d73bd$var$load("7EorR"),
    $e5625560a29d73bd$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("8a9Dm", function(module, exports) {
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$var$isMigratedFromConnect = (app)=>{
    if (!app.properties) return false;
    const props = app.properties;
    return props.migratedFromConnect === true || props.migratedFromConnect === 'true';
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    if ($2cc1b73219e08564$var$isMigratedFromConnect(app) && app.migrationKey) return `ac:${app.migrationKey}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("lk93G"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("lk93G", function(module, exports) {

let $f8627e0aeed3fccf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f8627e0aeed3fccf$var$load("hJpvQ"),
    $f8627e0aeed3fccf$var$load("bIPPg"),
    $f8627e0aeed3fccf$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});

parcelRegister("6UqI3", function(module, exports) {
const $a3c7cd489159fe33$export$28eddf802cd184f7 = (spaceKey)=>{
    return spaceKey?.[0] === '~' ? 'personal' : 'global';
};
module.exports["getSpaceType"] = $a3c7cd489159fe33$export$28eddf802cd184f7;

});

parcelRegister("9fBoq", function(module, exports) {
parcelRequire("1c598");
var $1Aku8 = parcelRequire("1Aku8");

const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $1Aku8.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $1Aku8.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};
module.exports["extensionTitle"] = $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e;

});

parcelRegister("1c598", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);
parcelRequire("i3Ypo");
var $2JC3k = parcelRequire("2JC3k");
var $1Aku8 = parcelRequire("1Aku8");

parcelRequire("jUCNB");
var $gUjm2 = parcelRequire("gUjm2");
var $kg3OT = parcelRequire("kg3OT");
var $fsQJy = parcelRequire("fsQJy");


});

parcelRegister("i3Ypo", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);

var $9dbGT = parcelRequire("9dbGT");


var $1Aku8 = parcelRequire("1Aku8");


var $6sM2K = parcelRequire("6sM2K");


var $2JC3k = parcelRequire("2JC3k");


});

parcelRegister("9dbGT", function(module, exports) {
const $1ec3e8240f57817b$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $1ec3e8240f57817b$export$3ee8c58bb87b9685 = [
    ...$1ec3e8240f57817b$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];

});

parcelRegister("1Aku8", function(module, exports) {
var $d128cc36ec70c56c$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $d128cc36ec70c56c$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $d128cc36ec70c56c$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $d128cc36ec70c56c$export$beaef1891b3e7ca3;

});

parcelRegister("6sM2K", function(module, exports) {
const $0e3337cb4407ef3b$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("2JC3k", function(module, exports) {
var $d977f97374f9d2c9$export$6e95f5308d9156f9 = /*#__PURE__*/ function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
    return ExtensionEnvironment;
}({});
const $d977f97374f9d2c9$export$9a2372818e2520c6 = {
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    MACRO: 'xen:macro',
    TEST_MODULE: 'test:module'
};
const $d977f97374f9d2c9$export$f06ffa3aa6bfec95 = {
    BACKLOG_ACTION: 'jira:backlogAction',
    BOARD_ACTION: 'jira:boardAction',
    PERSONAL_SETTINGS_PAGE: 'jira:personalSettingsPage',
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};
module.exports["ExtensionEnvironment"] = $d977f97374f9d2c9$export$6e95f5308d9156f9;
module.exports["ConfluenceExtension"] = $d977f97374f9d2c9$export$9a2372818e2520c6;
module.exports["JiraExtension"] = $d977f97374f9d2c9$export$f06ffa3aa6bfec95;

});

parcelRegister("jUCNB", function(module, exports) {

var $fsQJy = parcelRequire("fsQJy");


var $kg3OT = parcelRequire("kg3OT");


var $gUjm2 = parcelRequire("gUjm2");


});

parcelRegister("fsQJy", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $8d78496ee677e86d$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $8d78496ee677e86d$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $8d78496ee677e86d$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $8d78496ee677e86d$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $8d78496ee677e86d$export$20b9f6acb0888554(effect) {
    return $8d78496ee677e86d$export$7e816460364ed464(effect) || $8d78496ee677e86d$export$eb5bd7f371e458af(effect) || $8d78496ee677e86d$export$f632ad3064955f31(effect);
}

});

parcelRegister("kg3OT", function(module, exports) {
const $bc3454970f51a505$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $bc3454970f51a505$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $bc3454970f51a505$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $bc3454970f51a505$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $bc3454970f51a505$export$caa8cab0db5b0a61(effect) {
    return $bc3454970f51a505$export$65d7078e01574f24(effect) || $bc3454970f51a505$export$709a27a9f80556b8(effect) || $bc3454970f51a505$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("gUjm2", function(module, exports) {
// From forge.ts
const $ce9f8921033c0d6d$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
var $ce9f8921033c0d6d$export$c8914e6b1e019577 = /*#__PURE__*/ function(EcosystemLicenseMode) {
    EcosystemLicenseMode["USER_ACCESS"] = "USER_ACCESS";
    return EcosystemLicenseMode;
}({});
const $ce9f8921033c0d6d$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $ce9f8921033c0d6d$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $ce9f8921033c0d6d$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $ce9f8921033c0d6d$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $ce9f8921033c0d6d$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $ce9f8921033c0d6d$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $ce9f8921033c0d6d$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $ce9f8921033c0d6d$export$24835b97bd9481e3 = /*#__PURE__*/ function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
    CompassContextTypes["ComponentImporter"] = "compass:componentImporter";
    return CompassContextTypes;
}({});
var $ce9f8921033c0d6d$export$1718b7e1799fa866 = /*#__PURE__*/ function(RenderingLocations) {
    RenderingLocations["AppConfigurationPage"] = "appConfigurationPage";
    RenderingLocations["OnboardingFlow"] = "onboardingFlow";
    return RenderingLocations;
}({});

});

parcelRegister("9MrOn", function(module, exports) {
/* ContentToolsButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $h82at = parcelRequire("h82at");

var $1cfRh = parcelRequire("1cfRh");


var $9VJDA = parcelRequire("9VJDA");


var $1qfLF = parcelRequire("1qfLF");


var $52EPl = parcelRequire("52EPl");

const $43c0d8bb08806c39$var$NOOP = ()=>{};
const $43c0d8bb08806c39$var$i18n = (0, $h82at.defineMessages)({
    triggerLabel: {
        id: "content-tools.more.icon.label",
        defaultMessage: "More actions"
    }
});
const $43c0d8bb08806c39$var$dropdownMenuCollaboratorStyle = null;
const $43c0d8bb08806c39$var$dropdownMenuNonCollaboratorStyle = null;
const $43c0d8bb08806c39$var$ContentToolsButtonComponent = ({ isDisabled: isDisabled, isOpen: isOpen = false, onOpenChange: onOpenChange = $43c0d8bb08806c39$var$NOOP, onPositioned: onPositioned = $43c0d8bb08806c39$var$NOOP, children: children, isExternalCollaborator: isExternalCollaborator = false })=>{
    'use no memo';
    const intl = (0, $1cfRh.default)();
    const [drodownMenuMaxHeight, setDropdownMenuMaxHeight] = (0, $42omo.useState)('auto');
    const dropdownMenuContainerRef = (0, $42omo.useRef)(null);
    const handleOnOpenChange = (obj)=>{
        onOpenChange(obj);
        if (obj.isOpen) {
            const distanceFromTop = dropdownMenuContainerRef.current?.getBoundingClientRect().bottom ?? 0;
            const availableHeight = window.innerHeight - distanceFromTop - 16;
            setDropdownMenuMaxHeight(`${availableHeight}px`);
        }
    };
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-id": "content-tools-dropdown-menu-container",
        "data-test-id": "content-tools-dropdown-menu-container",
        "data-testid": "content-tools-dropdown-menu-container",
        ref: dropdownMenuContainerRef,
        className: (0, $gMc0m.default)([
            "_18u019bv _1ul91tcg",
            isExternalCollaborator && "_18u0idpf _1ul91tcg"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $52EPl.default), {
        testId: "content-tools-dropdown-menu",
        appearance: "tall",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
                ...props,
                "data-id": "page-more-action-button",
                "data-test-id": "page-more-action-button",
                id: "tools-menu-trigger",
                label: intl.formatMessage($43c0d8bb08806c39$var$i18n.triggerLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                ref: triggerRef,
                appearance: "subtle",
                isDisabled: isDisabled
            }),
        placement: "bottom-end",
        isOpen: isOpen,
        onOpenChange: handleOnOpenChange,
        shouldFlip: false,
        onPositioned: onPositioned,
        shouldRenderToParent: true
    }, /*#__PURE__*/ $42omo.createElement("div", {
        style: {
            maxHeight: drodownMenuMaxHeight
        }
    }, children || null)));
};
$43c0d8bb08806c39$var$ContentToolsButtonComponent.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).node,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isExternalCollaborator: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    onOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    onPositioned: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
};
const $43c0d8bb08806c39$export$f221d384e5b0f4c3 = /*#__PURE__*/ (0, $42omo.memo)($43c0d8bb08806c39$var$ContentToolsButtonComponent);
module.exports["ContentToolsButton"] = $43c0d8bb08806c39$export$f221d384e5b0f4c3;

});


//# sourceMappingURL=ForgeContentTools.7d906351.js.map
